module.exports = __webpack_public_path__ + "c25f3aacaa6b0efb7f7d027de089c2b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/press_teaser_201509_rn_2.jpg
// module id = 637
// module chunks = 0